const getImagePath = (imageName) => {
  // Get current hostname (domain) and protocol (http or https)
  const { protocol, host } = window.location;

  // Construct image path based on current host and protocol
  return `${protocol}//${host}/${imageName}`;
};

export default getImagePath;
